import React from 'react';

const RadioGroup = props => {
    const { className = 'app__custom-radiogroup', name, label, register, options, ...rest } = props;

    return (
        <div className={`${className}`}>
            <div className="app__editable-input__label">{label}</div>
            {options.map(option => (
                <label className={`${className}__input`}>
                    <input
                        type="radio"
                        name={name} {...register} {...rest}
                        value={option.value}
                    />
                    {option.label}
                </label>
            ))}
        </div>
    );
};

export default RadioGroup;
